if (!customElements.get('libero-search-discovery')) {
  customElements.define('libero-search-discovery', class extends HTMLElement {
    connectedCallback() {
      this.input = document.getElementById(this.dataset.inputId);
      if (!this.input) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.sync = () => { this.hidden = this.input.value.trim().length > 0; };
      this.input.addEventListener('input', this.sync, options);
      this.input.addEventListener('focus', this.sync, options);
      this.input.form.addEventListener('reset', () => queueMicrotask(this.sync), options);
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
